var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4998 20.0002V18.4715C32.4998 14.4257 32.4998 12.4027 33.6848 11.004C34.8696 9.60526 36.8651 9.27271 40.8558 8.60756L46.7476 7.62561C47.0871 7.56901 47.2568 7.54071 47.3486 7.63993C47.4401 7.73916 47.3983 7.90611 47.3148 8.24006L45.0766 17.1933C45.0393 17.3425 45.0206 17.417 44.9681 17.4671C44.9158 17.5171 44.8403 17.5321 44.6896 17.5623L32.4998 20.0002V35.0002V41.883C32.4998 46.5202 29.0468 50.432 24.4453 51.007L23.0513 51.1812C17.7373 51.8455 13.2463 47.275 14.0036 41.9735C14.5752 37.9722 18.002 35.0002 22.0439 35.0002H32.4998V20.0002Z",
    fill: "#787777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4998 35.0002H22.0439C18.002 35.0002 14.5752 37.9722 14.0036 41.9735C13.2463 47.275 17.7373 51.8455 23.0513 51.1812L24.4453 51.007C29.0468 50.432 32.4998 46.5202 32.4998 41.883V18.4715C32.4998 14.4257 32.4998 12.4027 33.6848 11.004C34.8696 9.60526 36.8651 9.27271 40.8558 8.60756L46.7476 7.62561C47.0871 7.56901 47.2568 7.54071 47.3486 7.63993C47.4401 7.73916 47.3983 7.90613 47.3148 8.24006L45.0766 17.1933C45.0393 17.3425 45.0206 17.417 44.9681 17.4671C44.9158 17.5171 44.8403 17.5321 44.6896 17.5623L32.4998 20.0002",
    stroke: "currentColor",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicFill);
export default __webpack_public_path__ + "static/media/MusicFill.7448841d266236993099458e56ddaa71.svg";
export { ForwardRef as ReactComponent };